var IpcImages = require("../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var NonElectroMechanical = [
        {
            name: 'SOIC, SOP',
            thumbnail: IpcImages.soic.thumbnail,
            dataType: 'SoicSopData',
            localeKey: "SOIC_SOP"
        },
        /*{
            name: 'CFP',
            thumbnail: IpcImages.cfp.thumbnail,
            dataType: 'CfpData'
        },*/
        {
            name: 'QFP',
            thumbnail: IpcImages.qfp.thumbnail,
            dataType: 'QfpData',
            localeKey: "QFP"
        },
        /*{
            name: 'CQFP',
            thumbnail: IpcImages.cqfp.thumbnail,
            dataType: 'CqfpData'
        },*/
        {
            name: 'QFN',
            thumbnail: IpcImages.qfn.thumbnail,
            dataType: 'QfnData',
            localeKey: "QFN"
        },
        {
            name: 'SOT23',
            thumbnail: IpcImages.sot23.thumbnail,
            dataType: 'Sot23Data',
            localeKey: "SOT23"
        },
        {
            name: 'SOTFL',
            thumbnail: IpcImages.sotfl.thumbnail,
            dataType: 'SotflData',
            localeKey: "SOTFL"
        },
        {
            name: 'SOT223',
            thumbnail: IpcImages.sot223.thumbnail,
            dataType: 'Sot223Data',
            localeKey: "SOT223"
        },
        {
            name: 'TO, DPAK',
            thumbnail: IpcImages.dpak.thumbnail,
            dataType: 'ToDpakData',
            localeKey: "TO_DPAK"
        },
        {
            name: 'SOT143',
            thumbnail: IpcImages.sot143.thumbnail,
            dataType: 'Sot143Data',
            localeKey: "SOT143"
        },
        {
            name: 'Chip',
            thumbnail: IpcImages.chip.thumbnail,
            dataType: 'ChipData',
            localeKey: "CHIP"
        },
        {
            name: 'SOD',
            thumbnail: IpcImages.sod.thumbnail,
            dataType: 'SodData',
            localeKey: "SOD"
        },
        {
            name: 'Molded Body',
            thumbnail: IpcImages.moldedBody.thumbnail,
            dataType: 'MoldedBodyData',
            localeKey: "MOLDED_BODY"
        },
        {
            name: 'SODFL',
            thumbnail: IpcImages.sodfl.thumbnail,
            dataType: 'SodflData',
            localeKey: "SODFL"
        },
        {
            name: 'DFN-2',
            thumbnail: IpcImages.dfn2.thumbnail,
            dataType: 'Dfn2Data',
            localeKey: "DFN_2"
        },
        {
            name: 'DFN-3',
            thumbnail: IpcImages.dfn3.thumbnail,
            dataType: 'Dfn3Data',
            localeKey: "DFN_3"
        },
        {
            name: 'DFN-4',
            thumbnail: IpcImages.dfn4.thumbnail,
            dataType: 'Dfn4Data',
            localeKey: "DFN_4"
        },
        {
            name: 'E-Cap',
            thumbnail: IpcImages.ecap.thumbnail,
            dataType: 'AluminumElectrolyticData',
            localeKey: "ECAP"
        },
        {
            name: 'Crystal',
            thumbnail: IpcImages.crystal.thumbnail,
            dataType: 'CrystalData',
            localeKey: "CRYSTAL"
        },
        {
            name: 'BGA',
            thumbnail: IpcImages.bga.thumbnail,
            dataType: 'BgaData',
            localeKey: "BGA"
        },
        {
            name: 'MELF',
            thumbnail: IpcImages.melf.thumbnail,
            dataType: 'MelfData',
            localeKey: "MELF"
        },
        {
            name: 'Chip Array, 2 Side Flat/Concave',
            thumbnail: IpcImages.chipArray2FlatConcave.thumbnail,
            dataType: 'ChipArrayTwoSideFlatConcaveData',
            localeKey: "CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE"
        },
        {
            name: 'Chip Array, 4 Side Flat/Concave',
            thumbnail: IpcImages.chipArray4FlatConcave.thumbnail,
            dataType: 'ChipArrayFourSideFlatConcaveData',
            localeKey: "CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE"
        },
        {
            name: 'Chip Array, 2 Side Convex',
            thumbnail: IpcImages.chipArray2Convex.thumbnail,
            dataType: 'ChipArrayTwoSideConvexData',
            localeKey: "CHIP_ARRAY_TWO_SIDE_CONVEX"
        },
        {
            name: 'PLCC',
            thumbnail: IpcImages.plcc.thumbnail,
            dataType: 'PlccData',
            localeKey: "PLCC"
        },
        {
            name: 'Oscillator Corner Concave',
            thumbnail: IpcImages.oscCornerConcave.thumbnail,
            dataType: 'OscillatorCornerConcaveData',
            localeKey: "OSCILLATOR_CORNER_CONCAVE"
        },
        {
            name: 'Oscillator J-Lead',
            thumbnail: IpcImages.oscJLead.thumbnail,
            dataType: 'OscillatorJLeadData',
            localeKey: "OSCILLATOR_J_LEAD"
        },
        {
            name: 'Oscillator L-Bend',
            thumbnail: IpcImages.oscLBend.thumbnail,
            dataType: 'OscillatorLBendData',
            localeKey: "OSCILLATOR_L_BEND"
        },
        {
            name: 'SOJ',
            thumbnail: IpcImages.soj.thumbnail,
            dataType: 'SojData',
            localeKey: "SOJ"
        },
        {
            name: 'Axial',
            thumbnail: IpcImages.axial.thumbnail,
            dataType: 'AxialData',
            localeKey: "AXIAL"
        },
        {
            name: 'DIP',
            thumbnail: IpcImages.dip.thumbnail,
            dataType: 'DipData',
            localeKey: "DIP"
        },
        {
            name: 'Pin Header (Male) Straight',
            thumbnail: IpcImages.headerStraight.thumbnail,
            dataType: 'HeaderStraightData',
            localeKey: "PIN_HEADER_STRAIGHT"
        },
        {
            name: 'Pin Header (Male) Right Angle',
            thumbnail: IpcImages.headerRightAngle.thumbnail,
            dataType: 'HeaderRightAngleData',
            localeKey: "PIN_HEADER_RA"
        },
        {
            name: 'Receptacle Header (Female) Straight',
            thumbnail: IpcImages.headerStraightSocket.thumbnail,
            dataType: 'HeaderStraightSocketData',
            localeKey: "RECEPTACLE_HEADER_STRAIGHT"
        },
        {
            name: 'Receptacle Header (Female) Right Angle',
            thumbnail: IpcImages.headerRightAngleSocket.thumbnail,
            dataType: 'HeaderRightAngleSocketData',
            localeKey: "RECEPTACLE_HEADER_RA"
        },
        {
            name: 'SON (DFN)',
            thumbnail: IpcImages.son.thumbnail,
            dataType: 'SonData',
            localeKey: "SON_DFN"
        },
        {
            name: 'Radial Generic (Round)',
            thumbnail: IpcImages.radialRound.thumbnail,
            dataType: 'RadialRoundData',
            localeKey: "RADIAL_GENERIC"
        },
        {
            name: 'Radial LED (Round)',
            thumbnail: IpcImages.radialLedRound.thumbnail,
            dataType: 'RadialLedRoundData',
            localeKey: "RADIAL_LED"
        },
        {
            name: 'Crystal (HC49)',
            thumbnail: IpcImages.crystalHC49.thumbnail,
            dataType: 'CrystalHC49Data',
            localeKey: "CRYSTAL_HC49"
        }
];

var ElectroMechanical = [
        {
            name: 'Female Standoff/Spacer',
            thumbnail: IpcImages.femaleStandoffSpacerData.thumbnail,
            dataType: 'FemaleStandoffSpacerData',
            localeKey: "FEMALE_STANDOFF"
        },
        {
            name: 'Male-Female Standoff',
            thumbnail: IpcImages.maleFemaleStandoffSpacerData.thumbnail,
            dataType: 'MaleFemaleStandoffSpacerData',
            localeKey: "MALE_FEMALE_STANDOFF"
        },
        {
            name: 'Snap Lock',
            thumbnail: IpcImages.SnapLockData.thumbnail,
            dataType: 'SnapLockData',
            localeKey: "SNAP_LOCK"
        }
];

var FusionOnly = [
        {
            name: 'Chip LED',
            thumbnail: IpcImages.ChipLed.thumbnail,
            dataType: 'ChipLedData',
            localeKey: "CHIP_LED"
        } 
];

module.exports.NonElectroMechanical = NonElectroMechanical;
module.exports.ElectroMechanical = ElectroMechanical;
module.exports.FusionOnly = FusionOnly;
